
$( document ).ready(function() {
    relations.init();
});

var relations = {
    container: null,

    init: function(container) {
        this.container = container || $('#relations');
        relations.registerLine(this.container, false);
    },

    registerLine: function(container, isNew) {
        if (isNew) initAutocompleter(container.find('.ctl-autocompleter'));
        container.find('.relation-save').click(function() {
            var row = $(this).closest('[data-id]');
            relations.save(row);
        });
        $.each(this.container.find('[data-id!=""]'), function() {
            var row = $(this);
            row.find('.relation-link').attr('href', '/Address/Detail/'+row.find('[name=RelationId]').val()).removeClass('d-none');
            row.find('[data-del]').removeClass('disabled');
        });
        container.find('[data-del]').click(function() {
            var row = $(this).closest('[data-id]');
            var id = row.attr('data-id');
            if (id.length == 0) return;

            messaging.askYesNo('Beziehung löschen?', 'Willst du diese Beziehung löschen?', function() {
                relations.delete(row);
            });
        });
    },

    save: function(row) {
        var id = row.attr('data-id');
        row.find('.is-invalid').removeClass('is-invalid');
        var addressId = relations.container.attr('data-addressId');
        var type = row.find('[name=Type]').val();
        var relationId = row.find('[name=RelationId]').val();
        if (!relationId) {
            row.find('.autocompleter-container').addClass('is-invalid');
            return;
        }
        var task = {
            run: function(onComplete, onTaskError) {
                $.ajax({
                    url: '/Address/SaveRelation/'+id,
                    data: {
                        addressId: addressId,
                        type: type,
                        relationId: relationId
                    },
                    type: 'post',
                    dataType: 'json',
                    timeout: connection.defaultTimeout,
                    success: function(data) {
                        messaging.showGlobalMessage("success", null, "Die Beziehung wurde gespeichert.");
                        connection.loadPart($('#rels-list'));
                        slidein.loadSlideIn('/Address/EditRelationsSlideIn?addressId=' + addressId);
                    },
                    error: function(data) {
                        if (data.statusText == 'timeout') {
                            onTaskError(null, true);
                            return;
                        }
                        onTaskError("Die Beziehung konnte nicht gespeichert werden: " + connection.getErrorMessageOf(data, ''), false, function() {
                            //revert
                        });
                    },
                    complete: function() {
                        if (onComplete != null) onComplete();
                    }
                });
            }
        };
        taskQueue.add(task);
    },

    delete: function(row) {
        var id = row.attr('data-id');
        var task = {
            run: function(onComplete, onTaskError) {
                $.ajax({
                    url: '/Address/DeleteRelation/'+id,
                    type: 'post',
                    dataType: 'json',
                    timeout: connection.defaultTimeout,
                    success: function() {
                        messaging.showGlobalMessage("success", null, "Die Beziehung wurde gelöscht.");
                        row.remove();
                        connection.loadPart($('#rels-list'));
                    },
                    error: function(data) {
                        if (data.statusText == 'timeout') {
                            onTaskError(null, true);
                            return;
                        }
                        onTaskError("Die Beziehung konnte nicht gelöscht werden: " + connection.getErrorMessageOf(data, ''), false, function() {
                            //revert
                        });
                    },
                    complete: function() {
                        if (onComplete != null) onComplete();
                    }
                });
            }
        };
        taskQueue.add(task);
    }

};
window.relations = relations;
